module.exports = __webpack_public_path__ + "img/PP_Sword_0177.74b1044b.png";